import {Injectable, inject} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {mergeMap, tap} from 'rxjs';
import {SurveyService} from '../../services';
import * as actions from './survey.actions';

@State<void>({name: 'survey'})
@Injectable({providedIn: 'root'})
export class SurveyState {
    surveyService = inject(SurveyService);

    @Action(actions.CreateSurvey)
    create({dispatch}: StateContext<void>, {survey}: actions.CreateSurvey) {
        return this.surveyService.post(survey).pipe(mergeMap(data => dispatch(new actions.GetSurveyResponse(data))));
    }

    @Action(actions.UpdateSurvey)
    update({dispatch}: StateContext<void>, {survey}: actions.UpdateSurvey) {
        return this.surveyService.patch(survey).pipe(
            mergeMap(data => {
                return dispatch(new actions.GetSurveyResponse(data));
            })
        );
    }

    @Action(actions.ActivateSurvey)
    activate({dispatch}: StateContext<void>, {survey}: actions.ActivateSurvey) {
        return this.surveyService.activate(survey).pipe(tap(data => dispatch(new actions.GetSurveyResponse(data))));
    }

    @Action(actions.DeleteSurvey)
    delete(context: StateContext<void>, {survey}: actions.DeleteSurvey) {
        return this.surveyService.delete(survey._id);
    }

    @Action(actions.RestoreSurvey)
    restore(context: StateContext<void>, {survey}: actions.RestoreSurvey) {
        return this.surveyService.restore(survey._id);
    }

    @Action(actions.GetSurvey)
    getOne({dispatch}: StateContext<void>, {id}: actions.GetSurvey) {
        return this.surveyService.getOne(id).pipe(tap(data => dispatch(new actions.GetSurveyResponse(data))));
    }

    @Action(actions.SearchSurveys)
    get({dispatch}: StateContext<void>, {data}: actions.SearchSurveys) {
        let obs = null;
        if (data.condition) obs = this.surveyService.search(data);
        else obs = this.surveyService.get(data);

        return obs.pipe(tap(data => dispatch(new actions.GetSurveysResponse(data, {state: 'success'}))));
    }
}
